<template>
  <div
    class="container"
    :class="{'is-pop':isFilter}"
  >
    <div class="header">
      <i
        class="icon-fanhui icon iconfont back"
        @click="goHome"
      ></i>
      <i
        class="icon iconfont icon-shaixuan time"
        @click="filter"
      ></i>
      <p class="text">{{active == 1 ? '回款排名' : '签约排名'}}</p>
      <p class="filter-time">{{region_list[date.u_region] && region_list[date.u_region]['name']}}</p>
      <p class="filter-time">{{date.begin_time}}-{{date.end_time}}</p>
      <!-- 背景图 -->
      <div class="header-bg">
        <div class="header-second"  @click="goDetail(rankData[1])">
          <img
            class="ihead"
            src="../../assets/img/t2.png"
            alt="第二名"
          >
          <img
            class="img"
            :src="rankData[1] && rankData[1]['avatar_path'] || defaultImg"
            alt="头像"
          >
          <div class="header-text">
            <h4 class="name">{{rankData[1] && rankData[1]['name']}}</h4>
            <p class="region">{{rankData[1] && rankData[1]['region']}}</p>
            <p class="money">{{rankData[1] && rankData[1]['money'] || '0.00'}}W</p>
          </div>
        </div>
        <div class="header-first">
          <div class="header-first-bg" @click="goDetail(rankData[0])">
            <img
              class="ihead"
              src="../../assets/img/t1.png"
              alt="第一名"
            >
            <img
              class="img"
              :src="rankData[0] && rankData[0]['avatar_path'] || defaultImg"
              alt="头像"
            >
            <div class="header-text">
              <h4 class="name">{{rankData[0] && rankData[0]['name']}}</h4>
              <p class="region">{{rankData[0] && rankData[0]['region']}}</p>
              <p class="money">{{rankData[0] && rankData[0]['money'] || '0.00'}}W</p>
            </div>
          </div>
        </div>
        <div class="header-third" @click="goDetail(rankData[2])">
          <img
            class="ihead"
            src="../../assets/img/t3.png"
            alt="第三名"
          >
          <img
            class="img"
            :src="rankData[2] && rankData[2]['avatar_path'] || defaultImg"
            alt="头像"
          >
          <div class="header-text">
            <h4 class="name">{{rankData[2] && rankData[2]['name']}}</h4>
            <p class="region">{{rankData[2] && rankData[2]['region']}}</p>
            <p class="money">{{rankData[2] && rankData[2]['money'] || '0.00'}}W</p>
          </div>
        </div>
      </div>
      <!-- 背景图 -->
    </div>
    <div
      class="zhezhao"
      v-if="isFilter"
      @click="cancel"
    ></div>

    <div class="body">
      <div class="body-btn">
        <div
          class="caseleft"
          :class="{'active':active ==1}"
          @click="onTabChange(1)"
        >
          回款排名
        </div>
        <div
          class="caseright"
          :class="{'active':active ==2}"
          @click="onTabChange(2)"
        >
          销售排名
        </div>
      </div>
      <!-- 回款排名 start -->
      <template v-if="active == 1">
      <emptyData v-show="backsStatus"></emptyData>
      <ul
        class="body-box"
      >
        <li
          v-for="(item,index) in backs"
          :key="item.id"
          @click="goDetail(item)"
        >
          <span class="body-box-index">{{index + 4}}</span>
          <div class="body-box-text">
            <img
              class="body-box-img"
              :src="item.avatar_path || defaultImg"
              :alt="item.name"
            >
            <div class="body-box-name">
              {{item.name}}
              <p class="body-box-region">{{item.region}}</p>
            </div>
          </div>
          <span class="body-box-money">
            {{item.b_money || '0.00'}} W
          </span>
        </li>
      </ul>
      </template>
      <!-- 回款排名 end -->
      <!-- 销售排名 start -->
      <template  v-if="active == 2">
      <emptyData v-show="salesStatus"></emptyData>
      <ul
        class="body-box"
        v-show="active == 2"
      >
        <li
          v-for="(item,index) in sales"
          :key="item.id"
            @click="goDetail(item)"
        >
          <span class="body-box-index">{{index + 4}}</span>
          <div class="body-box-text">
            <img
              class="body-box-img"
              :src="item.avatar_path || defaultImg"
              :alt="item.name"
            >
            <div class="body-box-name">
              {{item.name}}
              <p class="body-box-region">{{item.region}}</p>
            </div>
          </div>
          <span class="body-box-money">
            {{item.t_money || '0.00'}} W
          </span>
        </li>
      </ul>
      </template>
      <!-- 销售排名 end -->
    </div>
    <div
      class="selbox"
      v-if="isFilter"
    >
      <p>筛选</p>

      <p class="content">
        时间
      </p>
      <ul class="listtime">
        <mt-picker
          :slots="slots"
          @change="onDateChange"
          valueKey="name"
          class="inner-picker"
          :visibleItemCount="3"
        ></mt-picker>
      </ul>
      <p class="content">
        区域
      </p>
      <ul class="listtime">
        <li
          :class="{'true': item.id == c_region[0]}"
          v-for="(item) in region_list"
          @click="onRegionChang(item.id)"
          :key="item.id"
        >{{item.name}}</li>
      </ul>
      <p
        class="btnyes"
        @click="confirmFilter"
      >确定</p>
    </div>

  </div>
</template>
<script>
import { Popup, Picker } from 'mint-ui'
import { Navbar, TabItem } from 'mint-ui';


import Vue from 'vue'
import slotsList from '../../assets/js/slotsList'
import dateChange from '../../mixins/dateChange.js'
import regionChange from '../../mixins/regionChange.js'
import defaultImg from '../../assets/img/user-avatar.png'
import emptyData from '../public/nodata'
Vue.component(Popup.name, Popup)
Vue.component(Picker.name, Picker)
Vue.component(Navbar.name, Navbar)
Vue.component(TabItem.name, TabItem)
export default {
  mixins: [dateChange, regionChange],
  components: {
      emptyData
    },
  data() {
    return {
      active: 1,
      defaultImg,
      date: {
        begin_time: '',
        end_time: '',
        u_region: 0,
      },
      backs: [],
      sales: [],
      backsStatus:false,
      salesStatus:false,
      rankData: [],
      isFilter: false,
      slots: slotsList.Monthslots(),
    }
  },
  created() {
    let originData = this.$route.query || {}
    this.date.begin_time = originData.begin_time
    this.date.end_time = originData.end_time
    this.getData(this.date)
  },
  methods: {
    getData(data) {
      if (this.active == 1) {
        this.$notice.loading()
        this.$http.getBackRankSort(data).then(res => {
          this.rankData = this.getTopThree(res.data.backs)
          res.data.backs.length === 0 ? this.backsStatus = true : this.backsStatus = false
          res.data.backs.splice(0,3)
          this.backs = res.data.backs
          this.$notice.loading(false)
        })
      } else {
        this.$notice.loading()
        this.$http.getSaleRankSort(data).then(res => {
          this.rankData = this.getTopThree(res.data.pc, 't_money')
          res.data.pc.length === 0 ? this.salesStatus = true : this.salesStatus = false
          res.data.pc.splice(0,3)
           this.sales = res.data.pc
          this.$notice.loading(false)
        })
      }
    },
    goHome() {
      this.$router.push({ name: 'homepage' })
    },
    goDetail(item) { // 查看签约钻取详情
       if (!item.uid) return false
       let data = {
          id: item.uid,
          begin_time: this.date.begin_time,
          end_time: this.date.end_time
        }
        window.localStorage.setItem('drillData', JSON.stringify(data))
        this.$router.push({ name: 'backdetail' })
      },
    getTopThree(data=[], money = 'b_money') {
      let temp = []
      for (let i = 0; i < 3; i++) {
        let row = data[i] || {}
        temp.push({
          uid: row['uid'],
          avatar_path: row['avatar_path'],
          name: row['name'],
          region: row['region'],
          money: row[money],
        })
      }
      return temp
    },
    onTabChange(index) {
      this.active = index
      this.getData(this.date)
    },
    confirmFilter() {

      this.date.begin_time = this.c_begin_time
      this.date.end_time = this.c_end_time
      this.date.u_region = this.c_region

      this.isFilter = false
      this.getData(this.date)

      this.$emit('noFilter')
    },
    cancel() { //点击阴影取消
      this.isFilter = false
      this.$emit('noFilter')
    },
    filter() { //显示过滤弹窗
      this.slots = slotsList.Monthslots(this.date.begin_time, this.date.end_time)
      this.isFilter = true
      this.$emit('inFilter')
    },
  }
}
</script>
<style scoped>
.container {
  width: 100%;
}
.container.is-pop {
  height: 90vh;
  overflow: hidden;
}
.header {
  position: relative;
  width: 100%;
  font-size: 0.375rem;
  height: 7.3rem;
  position: relative;
  margin-bottom: 0.3125rem;
  background: #5482d1;
}
.back {
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
  color: #fff;
}
.time {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  color: #fff;
}
.text {
  font-size: 0.4375rem;
  color: #fff;
  text-align: center;
  padding-top: 10px;
}
.filter-time {
  padding-top: 6px;
  text-align: center;
  width: 100%;
  font-size: 14px;
  color: #fff;
}
.header-bg {
  position: absolute;
  left: 2%;
  bottom: 3%;
  display: flex;
  justify-content: space-between;
  width: 96%;
  height: 147px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(247, 240, 253, 1) 100%
  );
  border-radius: 2px;
}
.header-first {
  position: relative;
  width: 34%;
}
.header-first-bg {
  position: absolute;
  top: -20px;
  width: 100%;
  height: 167px;
  margin: 0 auto;
  text-align: center;
  padding-top: 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  box-shadow: 5px 0px 5px -5px #a0a0a0, -5px 0px 5px -5px #a0a0a0;
}
.header-second {
  position: relative;
  width: 33%;
  text-align: center;
}
.header-third {
  position: relative;
  width: 33%;
  text-align: center;
}
.header-bg .ihead {
  position: absolute;
  left: 0.9rem;
  top: 0.2rem;
  display: inline-block;
  width: 1.3rem;
  z-index: 10;
}
.header-bg .img {
  position: absolute;
  left: 0.94rem;
  top: 0.65rem;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  z-index: 8;
}
.header-first-bg .ihead {
    top: 0.6rem;
}
.header-first-bg .img {
    top: 1.05rem;
}

.header-text {
  position: absolute;
  width: 100%;
  bottom: 0.3rem;
}
.header-bg .name {
  font-weight: normal;
  font-size: 14px;
  color: #333;
}
.header-bg .region {
  font-size: 12px;
  color: #999;
  margin: 0.02rem auto;
}
.header-bg .money {
  font-weight: bold;
  font-size: 14px;
  color: #333;
}
.body {
  width: 100%;
  margin-top: 1.4rem;
}
.body-btn {
  position: relative;
  width: 80%;
  margin: 0 auto;
}
.active {
  border-bottom: 0.0625rem solid #5482d2;
  color: #5482d2;
}
.caseleft {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50%;
  text-align: center;
  font-family: PingFangSC-Regular;
  color: #666666;
  font-size: 0.4375rem;
  font-weight: 500;
  height: 1.03125rem;
  line-height: 1.03125rem;
}
.caseleft p {
  width: 60%;
  text-align: center;
  margin: auto;
  height: 100%;
}
.caseright {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 50%;
  text-align: center;
  font-family: PingFangSC-Regular;
  color: #666666;
  font-size: 0.4375rem;
  font-weight: 500;
  height: 1.03125rem;
  line-height: 1.03125rem;
}
.caseright p {
  width: 60%;
  text-align: center;
  margin: auto;
  height: 100%;
}
.body-box {
  padding: 0.4rem;
}
.body-box li {
  display: flex;
  height: 1.4rem;
  margin-bottom: 0.2rem;
}
.body-box-index {
  width: 1.4rem;
  line-height: 1.1rem;
  color: #333333;
  font-size: 16px;
  text-align: center;
}
.body-box-text {
  width: 5rem;
  height: 1.1rem;
}
.body-box-img {
  float: left;
  width: 1.1rem;
  height: 1.1rem;
   border-radius: 50%;
}
.body-box-name {
  float: left;
  margin: 0.04rem 0 0 0.2rem;
  color: #333333;
  font-size: 14px;
}
.body-box-region {
  margin-top: 0.06rem;
  color: #999;
  font-size: 12px;
}
.body-box-money {
  padding-right: 0.2rem;
  font-size: 14px;
  height: 1.1rem;
  color: #5482d2;
  line-height: 1.1rem;
  font-weight: bold;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/ranking/index.vue